export function urlSafeBase64(input: string): string {
  // Based on: https://developer.mozilla.org/en-US/docs/Glossary/Base64
  const bytes = new TextEncoder().encode(input)
  const binString = Array.from(bytes, (byte) => String.fromCodePoint(byte)).join('')
  return btoa(binString).replace(/\+/g, '-').replace(/\//g, '_')
}
